(() => {
  if (window.__astraPhotoGalleryLoaded) return;
  window.__astraPhotoGalleryLoaded = true;
  const viewers = new WeakMap();
  const openerGestures = new WeakMap();
  const activeOpeners = new Map();
  const createViewer = (dialog) => {
    let photos;
    const sourceTrack = document.getElementById(dialog.dataset.aaGalleryTrack || '');
    if (sourceTrack) photos = Array.from(sourceTrack.querySelectorAll('img')).map((photo) => ({ src: photo.src, alt: photo.alt, caption: photo.alt }));
    else try { photos = JSON.parse(dialog.querySelector('[data-aa-gallery-photos]').textContent); } catch { return null; }
    photos = photos.filter((photo, index, all) => photo.src && all.findIndex((item) => item.src.split('?')[0] === photo.src.split('?')[0]) === index);
    if (!photos.length || typeof dialog.showModal !== 'function') return null;
    const stage = dialog.querySelector('[data-aa-gallery-stage]');
    const image = dialog.querySelector('[data-aa-gallery-photo]');
    const caption = dialog.querySelector('[data-aa-gallery-caption]');
    const position = dialog.querySelector('[data-aa-gallery-position]');
    const zoomButton = dialog.querySelector('[data-aa-gallery-zoom]');
    const closeButton = dialog.querySelector('[data-aa-gallery-close]');
    const pointers = new Map();
    let index = 0, zoom = 1, x = 0, y = 0, gesture, pinch, opener, restoreBody, pageY, lastTap = 0, wheelTimer;
    const notify = (action, input) => {
      if (!input?.isTrusted || !sourceTrack?.closest('.floor-mat-page')) return;
      dialog.dispatchEvent(new CustomEvent('astra:photo-gallery-interaction', { bubbles: true, detail: { action, photo: index + 1, zoom, userInitiated: true } }));
    };
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    const renderTransform = () => {
      const maxX = Math.max(0, (image.offsetWidth * zoom - stage.clientWidth + 24) / 2);
      const maxY = Math.max(0, (image.offsetHeight * zoom - stage.clientHeight + 24) / 2);
      x = clamp(x, -maxX, maxX);
      y = clamp(y, -maxY, maxY);
      image.style.transform = `translate(${x}px, ${y}px) scale(${zoom})`;
      stage.dataset.zoomed = String(zoom > 1.01);
      zoomButton.textContent = zoom > 1.01 ? dialog.dataset.zoomOutLabel : dialog.dataset.zoomInLabel;
      zoomButton.setAttribute('aria-pressed', String(zoom > 1.01));
    };
    const resetZoom = () => { clearTimeout(wheelTimer); zoom = 1; x = 0; y = 0; pointers.clear(); gesture = null; pinch = null; lastTap = 0; renderTransform(); };
    const showPhoto = (next, input, action) => {
      index = (next + photos.length) % photos.length;
      resetZoom();
      image.src = photos[index].src;
      image.alt = photos[index].alt || '';
      caption.textContent = photos[index].caption || '';
      position.textContent = dialog.dataset.positionLabel.replace('__NUMBER__', index + 1).replace('__COUNT__', photos.length);
      dialog.querySelectorAll('[data-aa-gallery-step]').forEach((button) => { button.hidden = photos.length < 2; });
      const nextPhoto = photos[(index + 1) % photos.length];
      if (photos.length > 1) { const preload = new Image(); preload.src = nextPhoto.src; }
      notify(action, input);
    };
    const toggleZoom = (input) => { zoom = zoom > 1.01 ? 1 : 2.5; x = 0; y = 0; lastTap = 0; renderTransform(); notify(zoom > 1.01 ? 'zoom_in' : 'zoom_out', input); };
    const open = (trigger, input) => {
      if (dialog.open) return;
      opener = trigger;
      pageY = window.scrollY;
      const body = document.body;
      restoreBody = Object.fromEntries(['position','top','width','overflow','paddingRight'].map((key) => [key, body.style[key]]));
      const gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      if (gap) body.style.paddingRight = `${parseFloat(getComputedStyle(body).paddingRight) + gap}px`;
      body.style.position = 'fixed';
      body.style.top = `-${pageY}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      showPhoto(sourceTrack ? Math.round(sourceTrack.scrollLeft / Math.max(1, sourceTrack.clientWidth)) : 0);
      dialog.showModal();
      closeButton.focus({ preventScroll: true });
      notify('open', input);
    };
    dialog.addEventListener('close', () => {
      if (restoreBody) Object.assign(document.body.style, restoreBody);
      restoreBody = null;
      resetZoom();
      window.scrollTo({ top: pageY || 0, behavior: 'instant' });
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    closeButton.addEventListener('click', (event) => { notify('close', event); dialog.close(); });
    dialog.addEventListener('cancel', (event) => notify('close', event));
    zoomButton.addEventListener('click', toggleZoom);
    dialog.querySelectorAll('[data-aa-gallery-step]').forEach((button) => button.addEventListener('click', (event) => showPhoto(index + Number(button.dataset.aaGalleryStep), event, Number(button.dataset.aaGalleryStep) > 0 ? 'next' : 'previous')));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const controls = Array.from(dialog.querySelectorAll('button')).filter((button) => !button.hidden && !button.disabled);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); showPhoto(index + (event.key === 'ArrowRight' ? 1 : -1), event, event.key === 'ArrowRight' ? 'next' : 'previous'); }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) { notify('close', event); dialog.close(); }
    });
    image.addEventListener('load', renderTransform);
    const measurePinch = () => {
      const [a, b] = Array.from(pointers.values());
      return { distance: Math.hypot(a.x - b.x, a.y - b.y), x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
    };
    stage.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      stage.setPointerCapture(event.pointerId);
      if (pointers.size === 1) gesture = { x: event.clientX, y: event.clientY, panX: x, panY: y, started: Date.now(), zoom, startZoom: zoom, multi: false };
      if (pointers.size === 2) { if (gesture) gesture.multi = true; pinch = { ...measurePinch(), zoom, panX: x, panY: y }; }
      stage.dataset.dragging = 'true';
    });
    stage.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 2 && pinch) {
        const current = measurePinch();
        zoom = clamp(pinch.zoom * current.distance / Math.max(1, pinch.distance), 1, 4);
        x = pinch.panX + current.x - pinch.x;
        y = pinch.panY + current.y - pinch.y;
        renderTransform();
      } else if (gesture && zoom > 1.01 && pointers.size === 1) {
        x = gesture.panX + event.clientX - gesture.x;
        y = gesture.panY + event.clientY - gesture.y;
        renderTransform();
      }
    });
    const endPointer = (event, cancelled) => {
      if (!pointers.has(event.pointerId)) return;
      const ending = gesture;
      const dx = ending ? event.clientX - ending.x : 0;
      const dy = ending ? event.clientY - ending.y : 0;
      pointers.delete(event.pointerId);
      pinch = null;
      if (pointers.size === 1) {
        const point = Array.from(pointers.values())[0];
        gesture = { ...ending, x: point.x, y: point.y, panX: x, panY: y, zoom, multi: true };
        return;
      }
      stage.dataset.dragging = 'false';
      gesture = null;
      if (cancelled || !ending) { lastTap = 0; return; }
      if (ending.multi) { if (Math.abs(zoom - ending.startZoom) > .05) notify('pinch', event); lastTap = 0; return; }
      if (ending.zoom <= 1.01 && zoom <= 1.01 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) { showPhoto(index + (dx < 0 ? 1 : -1), event, 'swipe'); return; }
      if (ending.zoom > 1.01 && Math.hypot(x - ending.panX, y - ending.panY) >= 12) notify('pan', event);
      if (Math.hypot(dx, dy) < 12 && Date.now() - ending.started < 350) {
        if (Date.now() - lastTap < 320) toggleZoom(event);
        else lastTap = Date.now();
      } else lastTap = 0;
    };
    stage.addEventListener('pointerup', (event) => endPointer(event, false));
    stage.addEventListener('pointercancel', (event) => endPointer(event, true));
    stage.addEventListener('wheel', (event) => {
      if (!dialog.open || !event.ctrlKey) return;
      event.preventDefault();
      zoom = clamp(zoom * Math.exp(-event.deltaY * .01), 1, 4);
      renderTransform();
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(() => { if (dialog.open) notify('pinch', event); }, 200);
    }, { passive: false });
    window.addEventListener('resize', () => { if (dialog.open) renderTransform(); });
    return { open };
  };
  const openFromTrigger = (trigger, event) => {
    const dialog = document.getElementById(trigger.dataset.aaGalleryOpen);
    if (!dialog) return;
    let viewer = viewers.get(dialog);
    if (!viewer) { viewer = createViewer(dialog); if (viewer) viewers.set(dialog, viewer); }
    if (!viewer) return;
    event.preventDefault();
    viewer.open(trigger, event);
  };
  document.addEventListener('pointerdown', (event) => {
    const trigger = event.target.closest?.('.fm-gallery-track[data-aa-gallery-open]');
    if (trigger) {
      openerGestures.set(trigger, { x: event.clientX, y: event.clientY, skipUntil: 0 });
      activeOpeners.set(event.pointerId, trigger);
    }
  }, true);
  document.addEventListener('pointermove', (event) => {
    const trigger = activeOpeners.get(event.pointerId);
    const start = trigger && openerGestures.get(trigger);
    if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 14) start.skipUntil = Date.now() + 500;
  }, true);
  document.addEventListener('pointerup', (event) => {
    const trigger = activeOpeners.get(event.pointerId);
    const start = trigger && openerGestures.get(trigger);
    if (start && (start.skipUntil || Math.hypot(event.clientX - start.x, event.clientY - start.y) > 14)) start.skipUntil = Date.now() + 500;
    activeOpeners.delete(event.pointerId);
  }, true);
  document.addEventListener('pointercancel', (event) => {
    const trigger = activeOpeners.get(event.pointerId);
    const start = trigger && openerGestures.get(trigger);
    if (start) start.skipUntil = Date.now() + 500;
    activeOpeners.delete(event.pointerId);
  }, true);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-aa-gallery-open]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    if ((openerGestures.get(trigger)?.skipUntil || 0) > Date.now()) return;
    openFromTrigger(trigger, event);
  });
  document.addEventListener('keydown', (event) => {
    const trigger = event.target.closest?.('.fm-gallery-track[data-aa-gallery-open]');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) openFromTrigger(trigger, event);
  });
})();
